var _path, _rect, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg05Notify(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.32178 8.27643C2.32178 3.85815 5.9035 0.276428 10.3218 0.276428C14.7401 0.276428 18.3218 3.85815 18.3218 8.27643V13.2764H2.32178V8.27643Z",
    fill: "#E7E6F0"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.321777,
    y: 13.2791,
    width: 20,
    height: 3,
    rx: 1.5,
    fill: "#E7E6F0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3218 20.2791C11.9786 20.2791 13.3218 18.936 13.3218 17.2791H7.32178C7.32178 18.936 8.66492 20.2791 10.3218 20.2791Z",
    fill: "#6B57EA"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg05Notify);
export default __webpack_public_path__ + "static/media/05_notify.a32260b8af71b2ae48d7de680d1808f8.svg";
export { ForwardRef as ReactComponent };